import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/giovambattistafazioli/Lavori/Github/react-animatecss/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "v040"
    }}>{`V0.4.0`}</h1>
    <h2 {...{
      "id": "new-features-added"
    }}>{`New features added`}</h2>
    <ul>
      <li parentName="ul">{`Added support for `}<inlineCode parentName="li">{`as`}</inlineCode>{` property`}</li>
      <li parentName="ul">{`Added new `}<inlineCode parentName="li">{`block`}</inlineCode>{` property`}</li>
      <li parentName="ul">{`Added new `}<inlineCode parentName="li">{`repeat`}</inlineCode>{` property`}</li>
      <li parentName="ul">{`Added (this) Changelog file`}</li>
      <li parentName="ul">{`Added a "complex" example in `}<inlineCode parentName="li">{`Bounce`}</inlineCode>{` component`}</li>
    </ul>
    <h2 {...{
      "id": "improvements"
    }}>{`Improvements`}</h2>
    <ul>
      <li parentName="ul">{`Improved the documentation with more examples and some fixes`}</li>
      <li parentName="ul">{`Reviewed the code under the hood`}</li>
      <li parentName="ul">{`Updates packages in particular the styled-components to v5.0`}</li>
    </ul>
    <h2 {...{
      "id": "deprecated"
    }}>{`Deprecated`}</h2>
    <ul>
      <li parentName="ul">{`Deprecated `}<inlineCode parentName="li">{`infinity`}</inlineCode>{` property. Use new `}<inlineCode parentName="li">{`repeat`}</inlineCode>{` property instead`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      